import { Component, Output, EventEmitter, Input, OnChanges, SimpleChanges, OnInit, ViewChild, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Service } from './ctl-gen-kontrol-arama.service';
import { DxButtonModule, DxTextBoxComponent, DxTextBoxModule } from 'devextreme-angular';
import { DkDxDataCtlTableComponent } from '../../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent';
import { debounceTime, Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { GenKontrolService } from '../ctl-gen-kontrol.service';
import { OrtakService } from '../../../../services/ortak.service';
import { CommonModule } from '@angular/common';
import { ColumnModel } from '../../../../models/dx-data-table.model';
import {DlistDto} from "@dabnet-kamu/libs/ui";
@Component({
  selector: 'dk-ctl-gen-kontrol-arama',
  standalone: true,
  imports: [DkDxDataCtlTableComponent, DxButtonModule,CommonModule, DxTextBoxModule],
  providers: [Service],
  templateUrl: './ctl-gen-kontrol-arama.component.html',
  styleUrls: ['./ctl-gen-kontrol-arama.component.scss'],
})
export class CtlGenKontrolAramaComponent implements OnChanges,  OnInit   {
  private destroyRef = inject(DestroyRef);
  public data: any;
  public selectedData: any = null;
  public columns: ColumnModel[];
  gridControlsList$: Observable<DlistDto>;
  public keyExpr: string
  @Input() control: any;
  @Input() selectMode: any;
  @Input() key!: string;
  @Input() controlName = "";
  @Input() filterColumn = "";
  @Input() filterColumnValue: any;
  // Hazır grid süzgeci (CtlGenKontrol.tercihFiltresi popup'ı: [kodAlanı, '=', yazılanKod]); verilirse filterColumnValue'dan önce gelir
  @Input() aramaFiltresi: any[] | null = null;
  @Input() customSearchShow = false;
  @Input() customSearchInfo = "Tüm Kolonllarda Detaylı Arama";
  @Output() private closePopup = new EventEmitter<string>();
  @Output() private changeControl = new EventEmitter<any>();
  @ViewChild(DxTextBoxComponent) searchInput!: DxTextBoxComponent;
    public searchValue: string= "";
        private typingSubject: Subject<string> = new Subject();
        private subscription!: Subscription;
      firstReadyCheck = true;
    private destroy$ = new Subject<void>();

  public filterValue:any
  constructor(
    private service: Service,
    private genKontrolService:GenKontrolService,
    public ortakService:OrtakService
  ) {
  }
  ngOnInit(): void {
    if(!this.control.dlistMetadata){
        this.ortakService.getControl(this.controlName).pipe(takeUntil(this.destroy$))
          .subscribe((data) => {
            this.control = data?.controlMetadata;
            //this.service.getDlist(this.control?.dlistCode);
            this.genKontrolService._gridControlsList.next(data?.controlMetadata.dlistMetadata)
            //if(this.labelText === "")this.labelText = this.control.controlDescription;
            if (data?.controlMetadata.dlistMetadata.baseEntity) {
              this.changeControl.emit(this.control)
            }
          });
    }
    if(this.aramaFiltresi){
      this.filterValue = this.aramaFiltresi
    } else if(this.filterColumnValue){
      this.filterValue = [this.filterColumn, 'startswith', this.filterColumnValue]
    }
    this.subscription = this.typingSubject.pipe(
      debounceTime(1000)
    ).subscribe(value => {
      this.performSearch(value);
    });
    this.gridControlsList$ = this.genKontrolService.gridControlsList$;
    this.genKontrolService.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x=>{
      this.columns = this.ortakService.setRecursiveFieldData([x],false);
      })

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['control']) {
      this.data = this.service.getData(this.control, this.key);
    }
  }

  focusChanged(e: any) {
    this.selectedData = e.row;
  }

onContentReady(e: any) {
  if(this.firstReadyCheck && this.searchInput){
    setTimeout(() => {
      this.searchInput.instance.focus();
      this.firstReadyCheck = false;
    }, 300);
  }
}
  performSearch(value: string) {
    this.data = this.service.getData(this.control, this.key,value);
  }

  onKeyInput(e: any) {
    const currentValue = e.event.target.value;
    this.typingSubject.next(currentValue);
  }

  onKeyDown(e: any) {
  if (e.event?.key === 'Enter') {
      this.filterColumnValue = undefined;
      this.closePopup.emit(this.selectedData);
    }
  }

  dblClickRow(e:any){
    this.filterColumnValue = undefined;
    this.closePopup.emit(e);
  }

  chooseBtnClick() {
    this.filterColumnValue = undefined;
    this.closePopup.emit(this.selectedData);
  }

  cancelBtnClick() {
    this.filterColumnValue = undefined;
    this.closePopup.emit(null);
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscription.unsubscribe();
  }
}
